import { useQuery } from "@tanstack/react-query";
import SimplePrompt from "./SimplePrompt";
import { useState } from "react";
import { getUserInfo } from "utilities/js/callouts/CalloutFactory";
import Constants from "utilities/js/Constants";
import CookieManager from "utilities/js/localstorage/CookieManager";

const cookieManager = new CookieManager();


const VerifyEmailPrompt = (props) => {

    const [showEmailVerifyPrompt, setShowEmailVerifyPrompt] = useState(false);

    const userInfoResponse = useQuery({
        queryKey: ['userInfo'],
        queryFn: () => getUserInfo(cookieManager.getValue(Constants.COOKIE_USER_EMAIL_KEY)),
        staleTime: Infinity,
        enabled: !!cookieManager.getValue(Constants.COOKIE_USER_EMAIL_KEY)
    });


    if(userInfoResponse.isSuccess){
        if(!userInfoResponse.data.email_verified && !showEmailVerifyPrompt){
            setShowEmailVerifyPrompt(true);
        }
    }

    function getEmailVerifyPrompt(){
        if(showEmailVerifyPrompt){
            return (<SimplePrompt message="For full access, you still need to verify your email address" variant="flush warning centered"></SimplePrompt>)
        }
        return (<></>);
    }
        
    return getEmailVerifyPrompt();

}

export default VerifyEmailPrompt;